<div [ngClass]='rtlLocale'>
    <div class="tt-my-downloads">
        <div *ngIf="package.length>0" class="container myDownloads" id="myDownloads">
            <h1 class="container downloadTitle">
                {{'index.download' | translate}}
            </h1>
            <div class="myDownloadsPara">
                <span [innerHTML]="'index.para1' | translate"></span><br>
                <span [innerHTML]="'index.para2' | translate"></span><br>
                <span [innerHTML]="'index.para3' | translate"></span>
            </div>
            <hr class="container dividerColor {{oemName}}-dividecolor-hrline">
            <div class="innerDownloadDiv-style" id="myInnerDownloadDiv">
                <div class="createDownloads" *ngFor="let data of package">
                    <div class="outerMainDiv" *ngFor="let val of data">
                        <div class="innerTitleDiv innercss">
                            <span class="innerTitleLeftSpan" [innerHtml]="val.NAME | translate"></span><br>
                            <span class="innerTitleRightSpan">{{val.VERSION}}
                            </span><br>
                            <div class="date-style"
                                [ngClass]="{'reduce-margin': selectedRegionDK, 'reduce-margin-locale':selectedLocale,'date-margin':selectedLocaleDateHRline,'reduce-margin-locale-PL':selectedLocalePLMXCZDK|| selectedLocaleNO}">
                                {{'index.date'
                                |
                                translate}} {{val.UPLOAD_DATE | date: 'MM-yyyy'}}</div>
                        </div>
                        <hr class="hrLine innerhrline"
                            [ngClass]="{'locale-hrline-style':selectedLocaleDateHRline || selectedLocaleNO || selectedRegionTR}">
                        <div class="innerSupportDiv"><img class="innerMainDiv"
                                src="assets/images/{{oemName}}/{{val.IMAGE_NAME}}" alt="Download img">
                            <div class="innerSpanDiv innerSpanCss" innerHTML="{{'index.MapMessage' | translate}}"
                                [ngClass]="{'extend-margin-bottom-innerSpanCss': extendMarginToggle}">
                            </div>
                            <div class="innerButtonDiv"><b>{{val.SIZE}}</b><button
                                    class="innerDownloadButton commomButtonPrimary"
                                    (click)="getUrlData(val.ID,val.NAME,val.VERSION, val.SIZE)">{{'index.download2' |
                                    translate | titlecase}}</button></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-melco-download-popup *ngIf="downloadPopupToggle" (closePopup)="closePopup($event)"
    [downloadUrlData]="downloadUrlData" [popupDisplayData]="popupDisplayData" [formDataDropDown]="formDataDropDown"></app-melco-download-popup>